import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../client';
import { useTenant } from '../../hooks/useTenant';
import type { SearchResponse, TimeRange } from '../types';
import { requireParam, requireTenant } from './queryGuards';

export function useSearch(query: string | null, timeRange: TimeRange = '7d') {
  const { tenantId } = useTenant();

  return useQuery<SearchResponse>({
    queryKey: ['search', tenantId, query, timeRange],
    queryFn: () => {
      const requiredTenantId = requireTenant(tenantId);
      const requiredQuery = requireParam(query, 'No query');
      return apiClient.search({ tenant_id: requiredTenantId, query: requiredQuery, time_range: timeRange });
    },
    enabled: !!tenantId && !!query && query.length > 0,
  });
}
